import { render, staticRenderFns } from "./ForgotAddressResults.vue?vue&type=template&id=6e860032&"
import script from "./ForgotAddressResults.vue?vue&type=script&lang=js&"
export * from "./ForgotAddressResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports